const namespaced = true;

const defaultState = () => {
  return {
    annualLeaseNotPer:"",
    types: ["Lease", "Finance", "Flooring"],
    show: false,
    type: "Lease",
    methods: ["Method1", "Method2"],
    method: "Method1",
    payment: "",
    residualValue: "",
    monthlyLeaseAmount: "",
    endLeaseTerm: "",
    monthlyPaymentFinance: "",
    totalPaidEndOfFinance: "",
    totalInterestPaidEndFinance: "",
    balanceEndFinance: "",
    avgMonthlyPayment: "",
    financeArr: [],
    showDetail: false,
    annualLease:"",
    predictedResi:""
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState())
  },
  SET_PRE_RESI(state,predictedResi){
    state.predictedResi = predictedResi;
  },
  SET_ANNUAL_NOT_PER(state,annualLeaseNotPer){
    state.annualLeaseNotPer = annualLeaseNotPer;
  },
  SHOW_DETAILED(state, showDetail) {
    state.showDetail = showDetail;
  },
  SET_ANNUAL_LEASE(state,annualLease){
    state.annualLease = annualLease
  },
  SET_PAYMENT_DETAILS(state, financeArr) {
    state.financeArr = financeArr;
  },
  SET_AVG_MONTHLY_PAYMENT(state, avgMonthlyPayment) {
    state.avgMonthlyPayment = avgMonthlyPayment;
  },
  SET_BALANCE_END_FINANCE(state, balanceEndFinance) {
    state.balanceEndFinance = balanceEndFinance;
  },
  SET_TOTAL_INTEREST_PAID_END_FINANCE(state, totalInterestPaidEndFinance) {
    state.totalInterestPaidEndFinance = totalInterestPaidEndFinance;
  },
  SET_TOTAL_PAID_END_OF_FINANCE(state, totalPaidEndOfFinance) {
    state.totalPaidEndOfFinance = totalPaidEndOfFinance;
  },
  SET_MONTHLY_PAYMENT_FINANCE(state, monthlyPaymentFinance) {
    state.monthlyPaymentFinance = monthlyPaymentFinance;
  },
  RESET_VALS(state, val) {
    state.balanceEndFinance = val;
    state.totalInterestPaidEndFinance = val;
    state.totalPaidEndOfFinance = val;
    state.monthlyPaymentFinance = val;
    state.residualValue = val;
    state.payment = val;
    state.monthlyLeaseAmount = val;
    state.endLeaseTerm = val;
    state.annualLease = val;
    state.annualLeaseNotPer = val;
    state.predictedResi = val;
  },
  SET_SHOW(state, show) {
    state.show = show;
  },
  SET_PAYMENT(state, payment) {
    state.payment = payment;
  },
  SET_RESIDUAL_VALUE(state, residualValue) {
    state.residualValue = residualValue;
  },
  SET_MONTHLY_LEASE_AMOUNT(state, monthlyLeaseAmount) {
    state.monthlyLeaseAmount = monthlyLeaseAmount;
  },
  SET_END_LEASE_TERM(state, endLeaseTerm) {
    state.endLeaseTerm = endLeaseTerm;
  },
  SET_TYPE(state, type) {
    state.type = type;
  },
  SET_METHOD(state, method) {
    state.method = method;
  },
  SET_RESIDEL_VALUE(state, residualValue) {
    state.residualValue = residualValue;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
